/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'

import { deleteCommonMetadata } from '../../../../assets/ts/data/common-metadata'
import { getUserProfile } from '../../../../assets/ts/data/user-profile'
import { convertDate } from '../../../../assets/ts/date-and-time/date-and-time'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import useCommonMetadata from '../../../../hooks/use-common-metadata'
import useUserProfile from '../../../../hooks/use-user-profile'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_VALUE,
  SELECT_OPTION,
} from '../../../../utils/constants/global-constants'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import { Dropdown, optionsTypes } from '../../../../utils/controls/select-options-data'
import AddEditView from './add-edit-view'

interface categoryItems {
  archived: boolean
  category: string
  categoryCode: number
  css: string
  eKey: number
  eTag: string
  modified: string
  section: string
  sectionCode: number
}

const Categories = (props: any) => {
  const { sections } = useContext(MetadataContext)
  const { commonMetadata, commonMetadataIsLoading, fetchCommonMetdata } = useCommonMetadata({
    isArchivedFilter: null,
  })

  const [categoryItems, setCategoryItems] = useState<categoryItems[]>([])

  const [clickedItem, setClickedItem] = useState<boolean>(false)
  const [showAddPopup, setshowAddPopup] = useState(false)
  const [showEdit, setEdit] = useState(false)

  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })
  const [sectionValue, setSectionValues] = useState<any>({
    sectionCode: ALL_SELECT_VALUE,
  })
  const [allCategories, setAllCategories] = useState<string[]>([])

  const sectionOption: optionsTypes[] = [
    ALL_SELECT_OPTION,
    ...sections.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    })),
  ]
  function addeditValue(showAddPopup: any) {
    setshowAddPopup(showAddPopup)
  }
  /* Function call on edit */
  const onEdit = (item: any) => {
    setInEditMode({
      rowKey: item.eKey,
      status: true,
    })
    setEdit(!showEdit)
    setshowAddPopup(false)
  }
  /* Function call on cancel */
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setEdit(!showEdit)
  }
  const onDelete = async (item: any) => {
    setClickedItem(item)
    setshowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }
  const onClickAlert = async (button: string, item: any) => {
    if (button === 'OK') {
      setClickedItem(false)
      await deleteCommonMetadata(item)
      await fetchCommonMetdata()
    } else {
      setClickedItem(false)
    }
  }

  useEffect(() => {
    const fetchUserProfiles = async () => {
      // Process and update categoryItems
      const updatedCategoryItems = await Promise.all(
        commonMetadata
          .filter(
            (c) =>
              c.MetadataType === 'Category' &&
              (sectionValue.sectionCode === -1 || c.ParentCode === sectionValue.sectionCode)
          )
          .map(async (cat) => {
            // Check if cat.ItemModifiedBy is not null before fetching user profile
            let userDisplayName = ''
            if (cat.ItemModifiedBy) {
              const userProfile = await getUserProfile({ userRID: cat.ItemModifiedBy })
              userDisplayName = userProfile[0]?.UserDisplayName || ''
            }

            return {
              archived: cat.IsArchived,
              category: cat.MetadataValue,
              categoryCode: cat.Code,
              css: cat.AdditionalValue1,
              deleted: !cat.AllowEdit,
              eKey: cat.eKey,
              eTag: cat.eTag,
              modified: `${userDisplayName} | ${convertDate(cat.ItemModified, 'date') ?? ''}`,
              section: cat.ParentCode
                ? sections.find((s) => s.Value === cat.ParentCode)?.Label
                : '',
              sectionCode: cat.ParentCode,
            }
          })
      )
      //sort by modified date
      updatedCategoryItems.sort((a, b) => b.modified.localeCompare(a.modified))
      const allcategories = updatedCategoryItems.map((category) => category.category)
      setAllCategories(allcategories)
      setCategoryItems(updatedCategoryItems)
    }

    fetchUserProfiles()
  }, [commonMetadata, sectionValue, sections])

  function onSectionChange(e: { label: string; value: number }) {
    setSectionValues((prevState) => ({
      ...prevState,
      sectionCode: e.value,
    }))
  }

  return (
    <div className='row m-0'>
      {clickedItem && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={(e) => onClickAlert(e, clickedItem)}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11'
                id='Section'
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={sectionOption}
                value={sectionValue.sectionCode}
              />
            </div>
            <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  setshowAddPopup(true)
                  setEdit(false)
                  setInEditMode({
                    rowKey: null,
                    status: false,
                  })
                }}
              />
            </div>
          </div>
        }
        name='Categories'
      />

      <div className='p-0 settings-main mt-2'>
        {showAddPopup && (
          <AddEditView
            allCategories={allCategories}
            cancel={() => onCancel()}
            editItems={categoryItems}
            fetchCommonMetdata={fetchCommonMetdata}
            filtersvalue={addeditValue}
            sectionOption={sectionOption}
            showAddPopup={showAddPopup}
            toggleView={() => {
              setshowAddPopup(!showAddPopup)
            }}
          />
        )}
        {categoryItems.map((category: any) => (
          <div
            className='d-flex flex-column shadow card poppins-medium mb-2 py-3 my-2 mx-2'
            key={category.ItemKey}
          >
            <div className='d-flex px-2'>
              <div className='d-flex flex-column flex-md-row flex-wrap w-100'>
                <div aria-live='polite' className='d-flex flex-column col my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>Category</div>
                  <div className='poppins-semibold font-12 title-color2'>{category.category}</div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-250 w-100 max-w-250 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Section</div>
                  <div className='poppins-semibold font-12 title-color2 lineClamp2'>
                    {category.section}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-200 w-100 max-w-200 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Modified</div>
                  <div className='poppins-semibold font-12 title-color2 lineClamp2'>
                    {category.modified}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-80 w-100 max-w-80 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>CSS</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {category.css ? 'Yes' : 'No'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-80 w-100 max-w-80 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Is Archived</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {category.archived ? 'Yes' : 'No'}
                  </div>
                </div>
              </div>

              <div className='d-flex align-items-center'>
                <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                  <Buttons
                    aria-label='Edit'
                    className={
                      inEditMode.status && inEditMode.rowKey === category.eKey
                        ? 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold active'
                        : 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    }
                    icon='icon-pencil me-xl-1 font-10'
                    label='Edit'
                    onClick={() => onEdit(category)}
                  />
                  <Buttons
                    aria-label='Delete'
                    className='btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    icon='icon-trashbin me-xl-1 font-10'
                    label='Delete'
                    onClick={() => onDelete(category)}
                  />
                </div>
              </div>
            </div>
            {inEditMode.status && inEditMode.rowKey === category.eKey && (
              <AddEditView
                allCategories={allCategories}
                cancel={() => onCancel()}
                editItems={category}
                fetchCommonMetdata={fetchCommonMetdata}
                filtersvalue={addeditValue}
                sectionOption={sectionOption}
                showAddPopup={showAddPopup}
                showEdit={showEdit}
                toggleView={() => setClickedItem(false)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
export default Categories
